/* ============================================
   Dhenika — TESTIMONIALS DATA
   Path: constants/testimonials.js
   ============================================ */

const testimonials = [
  {
    id: 1,
    name: 'Sachin Shinde',
    role: 'Dairy Farmer, Maharashtra',
    avatar: '👨‍🌾',
    rating: 5,
    text:
      'Dhenika has completely changed how I manage my 30 cows. Earlier I used to forget vaccination dates — now the app reminds me automatically. Best app for farmers!',
  },
  {
    id: 2,
    name: 'Sunita Devi',
    role: 'Buffalo Farmer, Rajasthan',
    avatar: '👩‍🌾',
    rating: 5,
    text:
      'Maine pehle sab diary mein likhti thi. Ab Dhenika mein sab kuch hai — health records, vaccine dates, breeding history. Bahut aasaan hai use karna.',
  },
  {
    id: 3,
    name: 'Vijay Patil',
    role: 'Buffalo Farmer, Maharashtra',
    avatar: '🧑‍🌾',
    rating: 5,
    text:
      'I have 25 buffaloes and tracking each one was impossible before. Dhenika makes it simple. The deworming reminders alone have saved me so much money on vet bills.',
  },
  {
    id: 4,
    name: 'Meera Krishnan',
    role: 'Dairy Farmer, Tamil Nadu',
    avatar: '👩‍🌾',
    rating: 5,
    text:
      'Very easy to use even for someone not good with technology. My husband and I both use it together to manage our cows and buffaloes. The farm profile feature is really useful for us.',
  },
  {
    id: 5,
    name: 'Arjun Singh',
    role: 'Cattle Farmer, Punjab',
    avatar: '👨‍🌾',
    rating: 5,
    text:
      'The breeding tracker is excellent. I can see full history of each cow and buffalo and plan ahead. Highly recommend Dhenika to every farmer in India.',
  },
];

export default testimonials;